import React, { useRef } from 'react';

/**
 * İçerik yönetimi parça/ürün görsel yükleme alanı.
 * Dosya seçildiğinde doğrudan state'e yazmaz; onFileSelected ile editöre iletilir.
 */
function ContentFotoUploadZone({
  heading = 'Görsel',
  sub = 'Opsiyonel · tanıtım veya tanıma için küçük görsel',
  previewUrl,
  hasExistingFoto,
  hasNewFoto,
  canSelectFile,
  onFileSelected,
  onRemoveExisting,
  onClearNew,
}) {
  const inputRef = useRef(null);

  const handleFiles = (fileList) => {
    const f = fileList && fileList[0];
    if (f && String(f.type || '').startsWith('image/')) {
      onFileSelected(f);
    }
  };

  return (
    <div className="form-group content-foto-upload-group">
      <span className="content-foto-upload__heading">{heading}</span>
      <p className="content-foto-upload__sub">{sub}</p>

      {previewUrl && (
        <div className="content-foto-upload__preview-card">
          <img
            src={previewUrl}
            alt=""
            className="content-foto-upload__preview-img"
          />
          <div className="content-foto-upload__preview-actions">
            {hasExistingFoto && (
              <button
                type="button"
                className="content-foto-upload__text-btn content-foto-upload__text-btn--danger"
                onClick={onRemoveExisting}
              >
                <i className="fas fa-trash-alt" aria-hidden />
                Görseli kaldır
              </button>
            )}
            {hasNewFoto && (
              <button
                type="button"
                className="content-foto-upload__text-btn"
                onClick={onClearNew}
              >
                <i className="fas fa-undo" aria-hidden />
                Seçimi iptal et
              </button>
            )}
          </div>
        </div>
      )}

      <div
        className={`content-foto-upload__zone${canSelectFile ? '' : ' is-disabled'}`}
        onClick={() => {
          if (canSelectFile) inputRef.current?.click();
        }}
        onKeyDown={(e) => {
          if (!canSelectFile || (e.key !== 'Enter' && e.key !== ' ')) return;
          e.preventDefault();
          inputRef.current?.click();
        }}
        onDragOver={(e) => {
          if (!canSelectFile) return;
          e.preventDefault();
          e.stopPropagation();
        }}
        onDrop={(e) => {
          if (!canSelectFile) return;
          e.preventDefault();
          e.stopPropagation();
          handleFiles(e.dataTransfer?.files);
        }}
        role={canSelectFile ? 'button' : undefined}
        tabIndex={canSelectFile ? 0 : undefined}
        aria-label={canSelectFile ? 'Görsel seç veya sürükleyip bırak' : undefined}
      >
        <input
          ref={inputRef}
          type="file"
          className="content-foto-upload__native-input"
          accept="image/jpeg,image/png,image/gif,image/webp,image/*"
          disabled={!canSelectFile}
          onChange={(e) => {
            handleFiles(e.target.files);
            e.target.value = '';
          }}
        />
        {canSelectFile ? (
          <>
            <div className="content-foto-upload__zone-icon">
              <i className="fas fa-cloud-upload-alt" aria-hidden />
            </div>
            <span className="content-foto-upload__zone-title">Görsel yükle</span>
            <span className="content-foto-upload__zone-hint">
              Tıklayın veya dosyayı buraya sürükleyin · JPG, PNG, WebP
            </span>
            <span className="content-foto-upload__browse-pill">Dosya seç</span>
          </>
        ) : (
          <>
            <div className="content-foto-upload__zone-icon content-foto-upload__zone-icon--muted">
              <i className="fas fa-image" aria-hidden />
            </div>
            <span className="content-foto-upload__zone-title">Yeni görsel eklenemez</span>
            <span className="content-foto-upload__zone-hint">
              Önce yukarıdaki mevcut görseli kaldırın; ardından buradan yenisini seçin.
            </span>
          </>
        )}
      </div>
    </div>
  );
}

export default ContentFotoUploadZone;
